import React, { useEffect } from 'react';

export default function DataTest() {
  useEffect(() => {
    // 这里可以测试打桩代码
  }, []);
  return (
    <>
      测试ID:
      <input type="text" id="testIdInput" />
      <button
        type="button"
        style={{ marginLeft: '10px' }}
        onClick={() => {
          const testId = document.getElementById('testIdInput').value;
          const localMachineInfo = localStorage.getItem('LOCALMACHINE_INFO');
          const deviceId = localMachineInfo.MAC;
          if (deviceId == null) {
            alert('获取设备id失败');
            return;
          }
          const connectUrl = `http://sp.lenovomm.com/fui/dgcf/dgcf/appTest/connect?testId=${testId}&deviceId=${deviceId}`;
          fetch(connectUrl).then(response => {
            if (response.status === 200) {
              response.json().then(data => {
                // 获取请求的返回字段
                if (data.success === false) {
                  alert(data.message);
                } else {
                  alert('连接成功');
                }
              });
            } else {
              alert(`连接失败，响应状态:${response.status}`);
            }
          });
        }}
      >
        连接
      </button>
    </>
  );
}
